import React from 'react';
import QueryItem from '../components/query_item';
import SearchBar from './search_bar';
import { QueryListStyle} from '../styles/query_list_styles';
import {CSSTransition} from 'react-transition-group';
import '../styles/transitional_query.css';

const QueryBox = (props) => {
  const last_query_entered_ndx = props.data.query_terms - 1
  const queryItems = props.data.query_terms.map((term, ndx) => {
    if(props.data.trigger_fadein === true && ndx === last_query_entered_ndx){
      return (
        <CSSTransition in={true} timeout={3500} classNames='query' appear key={ndx}>
          <QueryItem
          props={props}
          onQuerySelect= {props.onQuerySelect}
          updateHoverState= {props.updateHoverState}
          disableHover= {props.disableHover}
          key= {ndx}
          ndx= {ndx}
          term= {term}
          />
        </CSSTransition>
      )
    }
    return (
          <QueryItem
          props={props}
          onQuerySelect= {props.onQuerySelect}
          updateHoverState= {props.updateHoverState}
          disableHover= {props.disableHover}
          key= {ndx}
          ndx= {ndx}
          term= {term}
          />
        );
    });
      return (
        <QueryListStyle>
          {queryItems}
          <SearchBar data={props.data} apiCall={props.apiCall} />
        </QueryListStyle>
      )
}

export default QueryBox;
